import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ApiClientInterface } from '../../client/api/api-client.interface';
import { DictionaryInterface } from '../data';
import { Transaction } from '../transaction/transaction';
import { TransactionRequestInterface } from '../transaction/transaction-request.interface';

@Injectable()
export class DictionaryApiRepository {
    constructor(private apiClient: ApiClientInterface, private transactionRequest: TransactionRequestInterface) {}

    load(): Observable<Transaction<DictionaryInterface[]>> {
        return this.transactionRequest.wrap(this.apiClient.getDictionary());
    }
}
